var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"proxy-warning-wrp"},[_vm._v("Performance of this website is impacted by a content filter or proxy. Please contact your provider to whitelist this website."),_c('span',{staticClass:"proxy-warning-dismiss",on:{"click":function($event){return _vm.dismiss()}}},[_vm._v("Dismiss temporarily")])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b41016","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/partials/AcceptProxyWarning.vue
// module id = 564
// module chunks = 187